import request from 'utils/request';

export default async function fetchManufactures(): Promise<any> {
  try {
    const { data: result } = await request(
      `/lineDriveService/masterData/manufacture`,
      {
        method: 'GET'
      }
    );

    return result;
  } catch (error) {
    console.log(error.message);
  }
}
